import { motion } from "framer-motion";
import { Sprout } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-2.5 text-xs font-semibold tracking-[0.24em] uppercase ${
      light ? "text-brand-wheat" : "text-brand-deep/60"
    }`}
  >
    <span className="w-7 h-px bg-brand-gold" />
    {children}
  </span>
);

export const Marquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="overflow-hidden py-7 border-y border-brand-deep/10 bg-brand-ivory select-none">
    <div className="flex w-max animate-marquee">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-outline-green px-6">{t}</span>
          <Sprout className="w-6 h-6 text-brand-gold shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
